import { Subscriber } from './video/opentok-connection';
import { VideoStream } from '../components/types/videos';
import { ConnectedUser } from '../stores/types/connection';

export default function printOTDebugLogForStreamId(
	streamId: string,
	overrides: {
    subscriber?: Subscriber | null;
    connectedPresenterVideos?: VideoStream[] | null;
    connectedUsers?: ConnectedUser[] | null;
  },
	resubscribe: Function | null = null,
	unsubscribe: Function | null = null,
	subscribe: Function | null = null,
) {
	const subscriber = overrides?.subscriber ?? window?.debugOT?.subscribers?.[streamId] ?? undefined;
	if (!subscriber?.stream) {
		console.log('printOTDebugLogForStreamId: no stream for subscriber => ', subscriber);
		return;
	}

	const {
		hasAudio,
		hasVideo,
		// @ts-ignore
		channel: channels,
		name,
	} = subscriber.stream;

	const id = name?.split(',')[0] ?? 0;
	const connectedPresenterVideos = overrides?.connectedPresenterVideos
		?? window?.debugOT?.connectedPresenterVideos
		?? [];
	const connectedUsers = overrides?.connectedUsers ?? window?.debugOT?.connectedUsers;
	const connectedPresenterVideo = connectedPresenterVideos?.find(
		(c: VideoStream) => Number(c.profile) === Number(id),
	);

	const connectedUser: ConnectedUser | undefined = connectedUsers?.find(
		(cu: ConnectedUser) => Number(cu.gr_user) === Number(id)
      || cu?.screenShareWebrtcId === streamId,
	);
	const altText = connectedUser?.screenShareWebrtcId === streamId
		? '\'s Screen Share'
		: '';
	const logName = `${connectedUser ? `${connectedUser.first_name} ${connectedUser.last_name}${altText}` : id}`;

	const muted = connectedPresenterVideo?.muted;
	const audioChannel = channels.find((c: { type: string }) => c.type === 'audio');
	const videoChannel = channels.find((c: { type: string }) => c.type === 'video');
	const srcObject = connectedPresenterVideo?.srcObject;

	if (
		!muted && (
			(audioChannel && !audioChannel?.active)
			|| (srcObject && !srcObject?.active)
		)
	) {
		console.log(`[${logName}] possible audio mismatch`);
	}

	const debugObject = {
		streamId,
		audioSettings: {
			muted,
			audioVolume: subscriber.getAudioVolume(),
			// @ts-ignore
			isAudioBlocked: subscriber.isAudioBlocked(),
			// @ts-ignore
			isLoading: subscriber.isLoading(),
			// @ts-ignore
			isSubscribing: subscriber.isSubscribing(),
		},
		hasAudio,
		hasVideo,
		audioChannel,
		videoChannel,
		connectedPresenterVideo,
		connectedUser,
		srcObject,
		subscriber,
	};

	const cleanupClosures = () => {
		delete window.debugOT?.resubscribes[`${logName} [${streamId}]`];
		delete window.debugOT.subscribes[`${logName} [${streamId}]`];
		delete window.debugOT.unsubscribes[`${logName} [${streamId}]`];
	};

	if (resubscribe && !window.debugOT.resubscribes[`${logName} [${streamId}]`]) {
		window.debugOT.resubscribes[`${logName} [${streamId}]`] = () => {
			resubscribe();
			cleanupClosures();
		};
	}
	if (subscribe && !window.debugOT.subscribes[`${logName} [${streamId}]`]) {
		window.debugOT.subscribes[`${logName} [${streamId}]`] = () => {
			subscribe();
			cleanupClosures();
		};
	}
	if (unsubscribe && !window.debugOT.unsubscribes[`${logName} [${streamId}]`]) {
		window.debugOT.unsubscribes[`${logName} [${streamId}]`] = () => {
			unsubscribe();
			cleanupClosures();
		};
	}

	console.log(`[${logName}] => `, {
		...debugObject,
		debugString: JSON.stringify(debugObject),
	});
}
